module.exports = __webpack_public_path__ + "static/img/android.bc0f6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/TdownloadRisk/img/android.png
// module id = +fkD
// module chunks = 2